import { Tag } from 'apprise-core/tag'
import { useTagService } from 'apprise-frontend-tags/service'

export const tagapi = "/tag"

export const useTagCalls = () => {

    const call = useTagService()


    const self = {

        fetchAllTags: () => call.at(tagapi).get<Tag[]>()
        
        ,

        addTag: (tag:Tag)  =>  call.at(tagapi).post<Tag>(tag)
        
        ,  

        updateTag: (tag:Tag)  =>  call.at(`${tagapi}/${tag.id}`).put<Tag>(tag)

        ,

        deleteTag: (tag:Tag)  =>  call.at(`${tagapi}/${tag.id}`).delete()

    }

    return self;

}

